import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] text-white pt-20 pb-10"
    >
      <div className="container-pro grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
        <div className="md:col-span-2">
          <div className="mb-6">
            <img
              src="/anila-logo.png"
              alt="Anila Consulting"
              data-testid="footer-logo"
              className="h-24 md:h-28 w-auto object-contain"
            />
          </div>
          <p className="text-white/70 max-w-md leading-relaxed">
            An IT business consulting firm specialising in SAP HANA/ECC,
            SAP B1, SAP ByD and Big Data Analytics — partnering with clients
            for their end-to-end IT needs across Retail, Manufacturing, FMCG,
            Oil, Real Estate and Infrastructure.
          </p>
          <div className="mt-8 flex flex-col gap-3 text-sm text-white/70">
            <span className="flex items-center gap-3">
              <Mail size={16} className="text-[#8B0000]" />
              <a
                href="mailto:anila@anilaconsulting.com"
                className="hover:text-white transition-colors"
              >
                anila@anilaconsulting.com
              </a>
            </span>
            <span className="flex items-start gap-3">
              <MapPin size={16} className="text-[#8B0000] mt-1 flex-shrink-0" />
              <span>
                Branches in Gurugram · Mumbai · Bangalore
              </span>
            </span>
          </div>

        </div>

        <div>
          <h4 className="font-display text-lg mb-5 text-white">Navigate</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li>
              <Link to="/" data-testid="footer-link-home" className="hover:text-white transition-colors">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" data-testid="footer-link-about" className="hover:text-white transition-colors">
                About
              </Link>
            </li>
            <li>
              <Link to="/services" data-testid="footer-link-services" className="hover:text-white transition-colors">
                Services
              </Link>
            </li>
            <li>
              <Link to="/team" data-testid="footer-link-team" className="hover:text-white transition-colors">
                Team
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-link-contact" className="hover:text-white transition-colors">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-5 text-white">Core Services</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li>SAP Implementation &amp; Migration</li>
            <li>SAP S/4HANA Enablement</li>
            <li>RISE with SAP &amp; Public Cloud</li>
            <li>Business Analytics &amp; Reporting</li>
            <li>Application Management Services</li>
            <li>SAP Upgrades &amp; Enhancements</li>
          </ul>
        </div>
      </div>

      <div className="container-pro mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center">
        <p className="text-xs text-white/50 tracking-wider uppercase">
          © {new Date().getFullYear()} Anila Consulting. All rights reserved.
        </p>
        <p className="text-xs text-white/50 tracking-wider uppercase">
          Empowering Business. Accelerating Growth.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
